import { WebSocketProvider } from './websocket-context'
import { NotificationProvider } from './notification-context'

export { WebSocketProvider, useWebSocket } from './websocket-context'
export { NotificationProvider, useNotifications } from './notification-context'

// Combined provider for easier usage
export const ChatProviders = ({ children }) => {
  return (
    <WebSocketProvider>
      <NotificationProvider>
        {children}
      </NotificationProvider>
    </WebSocketProvider>
  )
}
